<style scoped="true">
.form-control {
  font-size: 0.9rem;
  color: #333;
}
</style>

<template>
  <b-list-group>
    <draggable :list="questions" v-bind="dragOptions" @change="triggerUpdate">
      <transition-group>
        <b-list-group-item
          v-for="question in questions"
          :key="question.number"
          class="mb-1"
        >
          <b-row>
            <b-col cols="12">
              <strong># {{ question.number }}</strong>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="1" class="mt-1">
              <b-icon-list class="handle" scale="1.5" />
            </b-col>
            <b-col cols="11">
              <b-form-group>
                <b-form-input
                  debounce="400"
                  placeholder="La pregunta"
                  v-model="question.name"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group>
                <b-form-select v-model="question.type">
                  <b-form-select-option value="BOOLEAN"
                    >Check sencillo</b-form-select-option
                  >
                  <b-form-select-option value="SELECTABLE"
                    >Opción sencilla</b-form-select-option
                  >
                  <b-form-select-option value="MULTI_SELECTABLE"
                    >Opción multiple</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
              <b-form-group
                v-if="
                  question.type === 'SELECTABLE' ||
                  question.type === 'MULTI_SELECTABLE'
                "
              >
                <ul>
                  <li v-for="choice in question.choices" :key="choice.value">
                    {{ choice.name }}
                    <b-badge
                      variant="danger"
                      @click="removeChoice(question, choice)"
                      ><b-icon-x scale="1.5"
                    /></b-badge>
                  </li>
                </ul>
                <b-input-group>
                  <b-form-input debounce="300" v-model="currentChoice" placeholder="Agrega una opción">
                  </b-form-input>
                  <template v-slot:append>
                    <b-button size="sm" @click="addChoice(question)" variant="info"
                      ><b-icon-plus scale="1.75"
                    /></b-button>
                  </template>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-form-input
                  placeholder="Descripcion de la pregunta"
                  debounce="500"
                  v-model="question.description"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-badge
                variant="danger"
                href="#"
                @click="deleteQuestion(question)"
              >
                <b-icon-trash scale="1.5" />
              </b-badge>
            </b-col>
          </b-row>
        </b-list-group-item>
      </transition-group>
    </draggable>
    <b-list-group-item>
      <b-input-group>
        <b-form-input
          placeholder="Ingrese la pregunta"
          debounce="300"
          v-model="newQuestion"
        ></b-form-input>
        <template v-slot:append>
          <b-button variant="info" @click="appendQuestion">
            <b-icon-plus scale="1.5" />
          </b-button>
        </template>
      </b-input-group>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import draggable from "vuedraggable";

export default {
  name: "Questions",
  props: {
    category: {
      required: true,
      type: String,
    },
  },
  components: {
    draggable,
  },
  created() {
    this.questions = this.getQuestionsFromCategory(this.category);
  },
  data() {
    return {
      questions: [],
      newQuestion: "",
      currentChoice: "",
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 300,
        handle: ".handle",
      };
    },
    ...mapGetters("revision", ["getQuestionsFromCategory"]),
  },
  methods: {
    ...mapActions("revision", ["updateQuestions", "removeQuestion"]),
    appendQuestion() {
      if (this.newQuestion !== "") {
        this.questions.push({
          name: this.newQuestion,
          number: this.questions.length + 1,
          description: "",
        });

        this.triggerUpdate();
      }
      this.newQuestion = "";
    },
    deleteQuestion(question) {
      this.removeQuestion({ name: this.category, question });
      this.questions = [...this.getQuestionsFromCategory(this.category)];
    },
    addChoice(question) {
      if (!question.choices) {
        question.choices = [];
      }
      question.choices = [
        ...question.choices,
        { value: this.currentChoice, name: this.currentChoice },
      ];
      this.currentChoice = "";
    },
    removeChoice(question, choice) {
      question.choices = question.choices.filter((c) => choice.name !== c.name);
    },
    triggerUpdate() {
      this.updateQuestions({
        name: this.category,
        questions: this.questions,
      });

      this.questions = [...this.getQuestionsFromCategory(this.category)];
    },
  },
};
</script>
